import { KYMW9011Model } from '../kymw9011.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * パスワード再設定入力
 *
 * @export API通信成功時の処理
 * @class PasswordResetService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class PasswordResetService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9011Model;
  private successFunc: Function;
  private vo = {
    ConfirmCode: '',
    NewPassword: ''
  }

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof PasswordResetService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        PasswordReset: {
          condition: {
            ConfirmCode: this.vo.ConfirmCode,
            NewPassword: this.vo.NewPassword,
          }
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9011Model} model
   * @param {any} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof PasswordResetService
   */
  execute(model: KYMW9011Model, vo: any, successFunc: Function) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('passwordReset', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof PasswordResetService
   */
  success() {
    if(this.successFunc) {
      this.successFunc();
    }
  }
}
